import eye from '../assets/images/eye@3x.png';
import iconControlViewOff from '../assets/images/iconControlViewOff@3x.png';
import logoImage from '../assets/images/theBeansLogoPrimary@3x.png';
import React, { useEffect, useState } from 'react';
import ValidationItem from './ValidationItem';
import { useMutation } from '@apollo/client';
import { useNavigate } from 'react-router-dom';
import { UPDATE_USER_PASSWORD } from '../graphql/mutations/updatePassword';
import { useSearchParams } from 'react-router-dom';
import * as validatePassword from '../utils/validatePassword';
import '../styles/index.css';

const UpdatePassword = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [formValues, setFormValues] = useState({
    value: '',
    isPasswordHidden: true,
    isFocused: false,
  });

  const { value, isPasswordHidden, isFocused } = formValues;
  const token = searchParams.get('token') ?? null;
  const userId = searchParams.get('user_id') ?? null;
  const shouldEnableSubmitButton = validatePassword.validPasswordCreate(value);

  const [updateUserPassword] = useMutation(UPDATE_USER_PASSWORD, {
    onCompleted: () => {
      navigate('/success');
    }
  });

  const handleBlur = () => {
    setFormValues({ ...formValues, isFocused: false });
  };

  const handleFocus = () => {
    setFormValues({ ...formValues, isFocused: true });
  };

  const handlePasswordChange = (event) => {
    setFormValues({ ...formValues, value: event.target.value });
  };

  const togglePasswordVisibility = () => {
    setFormValues({
      ...formValues,
      isPasswordHidden: !formValues.isPasswordHidden
    });
  };

  const onPress = () => {
    updateUserPassword({ variables: { userId: Number(userId), token, newPassword: value } });
  };

  useEffect(() => {
    if (!token || !userId) {
      navigate('/error');
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token, userId]);
  

  console.log(searchParams.get('user_id'), 'token')

  return (
    <div className="password-reset-screen">
      <div className="password-reset-content">
        <img src={logoImage} alt="Logo" className="logo" />
        <h2 className="header-text">Enter your New Password</h2>

        <div className="input-container">
          <div className={`input-field ${isFocused ? "input-field-focused" : ""}`}>
            <input
              type={isPasswordHidden ? 'password' : 'text'}
              placeholder="New Password"
              className="input-text"
              onChange={handlePasswordChange}
              onFocus={handleFocus}
              onBlur={handleBlur}
              autoComplete="off"
            />
            <img
              src={isPasswordHidden ? iconControlViewOff : eye}
              alt="Password Icon"
              className="icon"
              onClick={togglePasswordVisibility}
            />
          </div>
        </div>

        <div className="validation-container">
          <div className="list">
            {ValidationItem("Minimum 14 characters", validatePassword.hasGreaterThan14Char(value))}
            {ValidationItem("One number", validatePassword.hasNumber(value))}
          </div>
          <div className="list">
            {ValidationItem("One uppercase letter", validatePassword.hasUpperCase(value))}
            {ValidationItem("One lowercase letter", validatePassword.hasLowerCase(value))}
          </div>
        </div>

        <button
          type="button"
          className={`submit-${shouldEnableSubmitButton ? 'enabled' : 'disabled'}`}
          disabled={!shouldEnableSubmitButton}
          onClick={onPress}
        >
          Confirm Password Change
        </button>
      </div>
    </div>
  );
};

export default UpdatePassword;
